export default {
      id: "logout-usage",
      viewBox: "0 0 30.999 31",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#logout",
      toString: function () {
        return this.url;
      }
    }